import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.disclaimer-title {
    text-align: center;
}
.disclaimer-title-fund-screener {
    padding: 16px;
    border-bottom: 1px #bbbbbb solid;
}
.content {
    padding: 0px 16px;
    margin-top: calc(8px * 2);
}
.close-btn-img {
    top: -10px;
}
.read-more-fund-screener {
    color: #086ea1;
    float: left;
    padding: 0px 16px;
    padding-top: calc(8px * 2);
}
.read-more-details {
    color: #086ea1;
    padding-top: calc(8px * 2);
    float: right;
}
.body {
    background-color: #fafafa;
    padding-bottom: 52px;
}
img {
    padding: 0px 10px 0px 0px;
    position: relative;
    right: 2px;
}
.img-outside {
    top: 5px;
}
.img-popup {
    top: 3px;
}
`;

export default styles;